import React from 'react';
import './credit.css';
export const Credit = () => {
  return (
    <>
      <div className='credits'>
        <p>
          By:{' '}
          <a href='https://www.github.com/faisalamin001' target='_blank'>
            Faysal
          </a>
        </p>
      </div>
    </>
  );
};
